import menu from './menu';

// console.log = function () { }

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
  } else {
      document.addEventListener("DOMContentLoaded", fn);
  }
}

const scrollTopLink = document.getElementById('js-scroll-top');

if(scrollTopLink) {
  scrollTopLink.addEventListener('click', (ev) => {
    ev.preventDefault();
    window.scrollTo(0, 0);
  })
}

if (
  document.getElementsByClassName('podcast') &&
  document.getElementsByClassName('podcast').length > 0
) {
  import('./podcast.js').then(
    module => {
      const podcast = module.default;
      podcast();
    },
  );
}

if (
  document.getElementsByClassName('js-contact') &&
  document.getElementsByClassName('js-contact').length > 0
) {
  import('./contact.js').then(
    module => {
      const contact = module.default;
      contact();
    },
  );
}

docReady(function() {
  if (
    document.getElementsByClassName('shop') &&
    document.getElementsByClassName('shop').length > 0
  ) {
    import('./shop.js').then(
      module => {
        const shop = module.default;
        shop();
      },
    );
  }
});

if (navigator.connection && navigator.connection.effectiveType && navigator.connection.saveData !== true) {
  switch (navigator.connection.effectiveType) {
    case "4g":
      // carbon();
      break;
    default:
  }
}
// analytics();
menu();



// button();
// colormode();
